import React from "react";
import { Router } from "@reach/router";
import LandingPage from "../views/LandingPage";
import LabelPage from "../views/LabelPage";
import SignUp from "../views/SignUp";
import Login from "../views/Login";
import VerifyEmail from "../views/VerifyEmail";
import ForgotPassword from "../views/ForgotPassword";
import ResetPassword from "../views/ResetPassword";
import CompleteProfile from "../views/CompleteProfile";
import Onboarding from "../views/Onboarding";
import ResultsPage from "../views/ResultsPage";
import OverviewPage from "../views/OverviewPage";
import TutorialPage from "../views/TutorialPage";
import PracticePage from "../views/PracticePage";
import ContactUs from "../views/ContactUs";

const PublicRoutes = () => (
    <Router>
        <LandingPage path="/" />
        <LabelPage path="label" />
        <ResultsPage path="/results" />
        <OverviewPage path="/overview" />
        <TutorialPage path="/tutorial" />
        <PracticePage path="/practice" />
        <ContactUs path="/contact" />
        <SignUp path="signup" />
        <Login path="login" />
        <VerifyEmail path="verify-email" />
        <ForgotPassword path="forgot-password" />
        <ResetPassword path="reset-password" />
        <CompleteProfile path="complete-profile" />
        <Onboarding path="onboarding" />
    </Router>
);

export default PublicRoutes;
